export const BETTER_IN_APP_EXPERIMENT = 'aud_mobile_aud3092_better_in_app';
export const AUD_MOBILE_PROMO_CIAN_APPS = 'aud_mobile_aud3259_promo_cian_apps';

export const EXPERIMENTS: string[] = [BETTER_IN_APP_EXPERIMENT, AUD_MOBILE_PROMO_CIAN_APPS];
